export const APP_FIREBASE_REMOTE_CONFIG_FETCH_START = 'APP_FIREBASE_REMOTE_CONFIG_FETCH_START';
export const APP_FIREBASE_REMOTE_CONFIG_FETCH_SUCCESS = 'APP_FIREBASE_REMOTE_CONFIG_FETCH_SUCCESS';

export const APP_SET_PATHNAME = 'APP_SET_PATHNAME';

export const APP_API_ERROR_SET = 'APP_API_ERROR_SET';
export const APP_API_ERROR_RESET = 'APP_API_ERROR_RESET';
